import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Modal, message } from 'antd'
import MyInput from '../../../components/forms/input'
import MyRichText from '../../../components/forms/richText'
import MyOrganizationSelect from '../../../components/select/organizationSelect'
import MyImageUpload from '../../../components/forms/imageUpload'
import MyDatePicker from '../../../components/forms/datePicker'
import MyRadio from '../../../components/forms/radio'
import MyTextArea from '../../../components/forms/textArea'

const EditAlumniEvent = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [formValue, setFormValue] = useState({})
  const [errorMsg, setErrorMsg] = useState({})

  useEffect(() => {
    axios.post('/p/alumni/event/detail/get', {
      merchant_oid: merchantOid,
      event_oid: props.data.oid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setFormValue(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }, [merchantOid, props.data])

  const handleOk = () => {
    setErrorMsg({})
    if (!formValue.title) {
      setErrorMsg({titleEmpty: '活动标题不能为空'})
      return false
    }
    if (!formValue.organization_oid) {
      setErrorMsg({organizationEmpty: '活动组织不能为空'})
      return false
    }
    if (!formValue.thumbnail_url) {
      setErrorMsg({thumbnailEmpty: '活动展示图不能为空'})
      return false
    }

    axios.post('/p/alumni/event/edit', { 
      merchant_oid: merchantOid,
      event_oid: props.data.oid,
      organization_oid: formValue.organization_oid,
      title: formValue.title,
      thumbnail_url: formValue.thumbnail_url,
      type: Number(formValue.type),
      address: formValue.address,
      description: formValue.description,
      start_time: formValue.start_time,
      end_time: formValue.end_time
    })
      .then(function (response) {
        if (response.errcode === 0) {
          handleCancel()
          props.getEventData()
          props.getAlumniEventDetail()
          message.success('修改成功！')
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const handleCancel = () => {
    setErrorMsg({})
    props.isCancel()
  }

  return (
    <Modal 
      title='编辑组织'
      destroyOnClose={true}
      width='760px'
      open={props.isOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      cancelText="取消"
      okText="保存">

      <MyImageUpload 
          id="thumbnail_url"
          required
          label='展示图'
          value={formValue.thumbnail_url}
          setValue={setFormValue}
          errorMsg={errorMsg.thumbnailEmpty}
        />

        <MyInput
          id="title"
          required
          autoFocus
          maxLength={64}
          label='名称'
          placeholder='请输入名称'
          value={formValue.title}
          onChange={setFormValue}
          errorMsg={errorMsg.titleEmpty}
        />

        <MyRichText
          id='description'
          label='介绍'
          value={formValue.description}
          setValue={setFormValue}
        />

        <MyOrganizationSelect
          id='organization_oid'
          required
          label='发起组织'
          value={formValue.organization_oid}
          onChange={setFormValue}
          errorMsg={errorMsg.organizationEmpty}
        />

        <MyRadio
          id='type'
          label='活动类型'
          options={[
            {
              label: '线上活动',
              value: 1,
            },
            {
              label: '线下活动',
              value: 2,
            }
          ]}
          defaultValue={1}
          value={formValue.type}
          onChange={setFormValue}
        />

        {formValue.type === 2 && <MyTextArea 
          id="address"
          minRows={2}
          placeholder='请输入活动地址'
          value={formValue.address}
          onChange={setFormValue}
        />}

        <MyDatePicker
          id="start_time"
          label='开始时间'
          placeholder='选择时间'
          value={formValue.start_time}
          onChange={setFormValue}
          styles={{width: '360px'}}
          showTime
        />

        <MyDatePicker
          id="end_time"
          label='结束时间'
          placeholder='选择时间'
          value={formValue.end_time}
          onChange={setFormValue}
          styles={{width: '360px'}}
          showTime
        />
      </Modal>
  )
}
export default EditAlumniEvent
